export default {
  HEADING: 'KV-Dienst am',
  HEADER: {
    LINK_BACK: 'Zurück',
    BOOKMARKS: 'Beobachter',
    APPLICATIONS: 'Bewerbungen',
    CHECK_INFO: 'Wir prüfen Ihre Angaben...',
    LOADING_FEDERATION: 'Wir warten auf den Verband',
  },
  SNACKBAR: {
    CLOSE: 'Schließen',
    MESSAGE: 'Das bereitgestellte Token ist abgelaufen oder stammt nicht vom akzeptierten Anbieter.',
  },
  SERVICE_OFFICE: 'Sitzdienst',
  SERVICE_MOBILE: 'Fahrdienst',
  INFORMATION: {
    CANCELLED: 'Dienst storniert',
    HEADING: 'Angaben zum Dienst',
    TYPE: 'Dienstart',
    START: 'Dienstbeginn',
    END: 'Dienstende',
    DURATION: 'Dienstdauer',
    BREAK_START: 'Pausenbeginn',
    BREAK_END: 'Pausenende',
    BREAK_DURATION: 'Pausendauer',
    STATE: 'Bundesland',
    AREA: 'Dienstgebiet',
    INVOLVEMENT: 'Notfallschein-Beteiligung',
    INVOLVEMENT_DEFAULT: ' pro Schein (ab dem 1. Patienten)',
    EXTRA_REMUNERATION: 'Notfallscheinbeteiligung',
    EXTRA_REMUNERATION_EXTRA_TEXT: '-pro Schein (ab dem {count}. Patienten)',
    EXTRA_REMUNERATION_INFO: '{count}. Patienten in {length} Std.',
    EXTRA_REMUNERATION_ONE_PATIENT: '1. Patienten',
  },
  COMMENT: {
    HEADING: 'Kommentar zum Dienstgebiet',
  },
  DISCLAIMER: {
    HEADING: 'Hinweise',
    DESCRIPTION: 'Bitte beachten Sie vor Ihrer Bewerbung folgende Hinweise, die wir zu diesem Dienst bekommen haben.',
    BREAK_DESCRIPTION:
      '* Bitte beachten Sie: Dieser Dienst beinhaltet eine Pause zwischen zwei Einsätzen. Es handelt sich nicht um einen durchgehenden Dienst über die angegebene Dauer.',
  },
  CARD: {
    CANCELLED: 'Dienst storniert',
    PUBLISHED: 'Veröffentlichter Dienst',
    OCCUPIED: 'Vergebener Dienst',
    CONCLUDED: 'Beendeter Dienst',
    CREATED_AT: 'Erstellt am',
    BOOKMARKS: 'Beobachter',
    APPLICATIONS: 'Bewerbungen',
    BUTTON_EDIT: 'Dienst bearbeiten',
    BUTTON_APPLICANTS: 'Zu den Bewerbern',
    BUTTON_OVERVIEW: 'Zu den Details',
    PARTNER: {
      BUTTON_DELETE: 'Dienst löschen',
      EDIT_DIALOG: {
        HEADING: 'Dienst bearbeiten',
        HOURS_HEADING: 'Dienstzeiten',
        BREAK_HEADING: 'Pause',
        BREAK_START: 'Pausenbeginn',
        BREAK_END: 'Pausenende',
        FEE_HEADING: 'Honorar',
        FEE_MIN: 'Honorar Minimum',
        FEE_MAX: 'Honorar Maximum',
        TIME_END: 'Uhrzeit Ende',
        CANCEL: 'Abbrechen',
        SAVE: 'Speichern',
      },
      DELETE_DIALOG: {
        HEADING: 'Dienst löschen',
        TEXT: 'Möchten Sie diesen Dienst wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        CANCEL: 'Abbrechen',
        CONFIRM: 'Dienst löschen',
      },
    },
    SUBSTITUTE: {
      FEE_PER_HOUR: 'Honorar pro Stunde',
      FEE_TOTAL: 'Honorar für gesamte Dienstzeit',
      FEE_PLACEMENT: 'nach erfolgreicher Vermittlung dieses Dienstes fällt eine Vermittlungsgebühr von {price} an.',
      CANCELLATION_FEE: 'Stornogebühr {price}.',
      CHECKBOX_TERMS_AND_CONDITIONS: `
      Ich akzeptiere die <a href="${import.meta.env.ARZTPOOL_META_WEBSITE_URL}agb#substitute" target="_blank">AGB</a> sowie den <a href="${
        import.meta.env.ARZTPOOL_META_BASE_URL
      }sampleContract" target="_blank">Vertretungsvertrag</a>
      `,
      CONTRACT: 'Mit einer verbindlichen Bewerbung akzeptieren Sie im Falle einer erfolgreichen Vermittlung den Dienstvertretungsvertrag.',
      DEFAULT: {
        HEADING: 'Ihr Honorar pro Stunde',
        DESCRIPTION:
          'Geben Sie bitte an, zu welchem Stundenhonorar Sie diesen KV-Dienst vertreten möchten. Mit Ihrer Bewerbung verpflichten Sie sich, den Dienst zu übernehmen, sofern Ihre Bewerbung angenommen wird.',
        DESCRIPTION_MINMAX_EQUAL:
          'Mit Ihrer Bewerbung zum angegebenen Honorar verpflichten Sie sich, den Dienst zu übernehmen, sofern Ihre Bewerbung angenommen wird.',
        BUTTON_WATCHLIST_ADD: 'Auf die Merkliste',
        BUTTON_WATCHLIST_REMOVE: 'Von Merkliste entfernen',
        BUTTON_APPLY: 'Verbindlich bewerben',
      },
      APPLIED: {
        ALERT: 'Ihre Bewerbung wurde erfolgreich übermittelt.',
        DESCRIPTION:
          'Geben Sie bitte an, zu welchem Stundenhonorar Sie diesen KV-Dienst vertreten möchten. Mit Ihrer Bewerbung verpflichten Sie sich, den Dienst zu übernehmen, sofern Ihre Bewerbung angenommen wird.',
        HEADING: 'Ihr Angebot',
        REMOVE_APPLICATION: 'Bewerbung zurückziehen'
      },
      ASSIGNED: {
        ALERT: 'Herzlichen Glückwunsch, Sie sind der Vertreter für diesen KV-Dienst.',
        HEADING: 'Ihr Honorar',
        DESCRIPTION: 'Sie können nun Nachrichten mit Ihrem Auftraggeber austauschen und den Dienstvertretungsvertrag herunterladen.',
        BUTTON: 'Details zum Dienst anzeigen',
      },
      CONCLUDED: {
        ALERT: 'Der Dienst wurde beendet.',
        DESCRIPTION: 'Finden Sie andere passende KV-Dienste und bewerben Sie sich in wenigen Schritten.',
        BUTTON_MARKETPLACE: 'Weitere Dienste finden',
        BUTTON_DETAILS: 'Details zum Dienst anzeigen',
      },
    },
  },
  PRIORITY: {
    HEADING:
      'Sie möchten den Dienst dringend abgeben und haben noch nicht den passenden Vertreter gefunden? Wählen Sie die Option "Priority", um mehr Aufmerksamkeit zu erzielen.',
    LABEL: 'Priority-Dienst',
    DESCRIPTION:
      'Diese Option empfiehlt sich, wenn es sich um einen kurzfristigen Termin handelt oder es um ein schnelles Ergebnis bei der Vertreterfindung gehen soll. Ihr Dienst wird hervorgehoben und erhält so schneller passende Angebote von Bewerbern.',
    SUBMIT: 'Option "Priority" verbindlich buchen',
  },
  IMMEDIATE: {
    HEADING: 'Sie möchten den Dienst unbedingt haben? Wählen Sie die Sofort-Zusage, um sich den Dienst direkt und ohne Wartezeit zu sichern.',
    FEE_PER_HOUR: 'Sofort-Zusage Honorar pro Stunde',
    FEE_TOTAL: 'Sofort-Zusage Honorar für gesamte Dienstzeit',
    SUBMIT: 'Sofort-Zusage verbindlich wählen',
  },
  SIMILAR: {
    HEADING: 'Ähnliche KV-Dienste',
  },
};
